export const getBrandFocusRing = (theme, inset = false) => inset
    ? `0 0 0 0px ${theme.colors?.surface?.default} inset, 0 0 0 2px ${theme.colors?.border?.focus} inset`
    : ` 0 0 0 2px ${theme.colors?.surface?.default}, 0 0 0 4px ${theme.colors?.border?.focus}`;
export const getDangerFocusRing = (theme, inset = false) => inset
    ? `0 0 0 0px ${theme.colors?.surface?.default} inset, 0 0 0 2px ${theme.colors?.effects?.focusRingError} inset`
    : `0 0 0 2px ${theme.colors?.surface?.default}, 0 0 0 4px ${theme.colors?.effects?.focusRingError}`;
//# sourceMappingURL=focus.js.map